import { Link } from 'react-router-dom';
import { getDeviceUrl } from 'util/device';
import useDevices from 'store/devices';

function CircuitTableControllerRow({row}) {
  const [state] = useDevices();

  return (
    <tr className="sub-head-row">
      <td>
        <strong>Controller</strong>:&nbsp;
        <Link to={getDeviceUrl(state.shallowDevices.get(row.id))}>
          {row.name}
        </Link>
      </td>
      <td colSpan="999"></td>
    </tr>
  )
}

export default CircuitTableControllerRow;
